export const DEFAULT_CANONICAL = [
    [1, 1],
    [4, 3],
    [3, 2],
    [16, 9],
    [16, 10],
    [5, 4],
    [21, 9],
    [2, 1],
    [3, 1],
    [1, 2],
    [9, 16],
    [3, 4],
    [2, 3]
];

export function gcd(a, b) {
    a = Math.abs(a);
    b = Math.abs(b);
    while (b) {
        const t = b;
        b = a % b;
        a = t;
    }
    return a;
}

export function aspectRatioExact(w, h, {
    canonical = DEFAULT_CANONICAL,
    includePortrait = true
} = {}) {
    if (!Number.isFinite(w) || !Number.isFinite(h) || w <= 0 || h <= 0) {
        throw new Error('w and h must be positive numbers');
    }

    w = Math.round(w);
    h = Math.round(h);

    const g = gcd(w, h);
    const arW = w / g;
    const arH = h / g;

    const isCanonical = canonical.some(([cw, ch]) => {
        if (cw === arW && ch === arH) return true;
        if (includePortrait && cw === arH && ch === arW) return true;
        return false;
    });

    return {
        arW,
        arH,
        isCanonical,
        approximate: false,
        label: `${arW}:${arH}`
    };
}

export function classifyAspect(w, h, arW, arH, maxPixelError = 1) {
    const g = gcd(arW, arH);
    const p = arW / g;
    const q = arH / g;

    if (w * q === h * p) {
        return 'exact';
    }

    const idealW = (h * p) / q;
    const wDelta = w - Math.round(idealW);

    if (Math.abs(wDelta) <= maxPixelError) {
        return wDelta > 0
            ? 'rounded_up_width'
            : 'rounded_down_width';
    }

    const idealH = (w * q) / p;
    const hDelta = h - Math.round(idealH);

    if (Math.abs(hDelta) <= maxPixelError) {
        return hDelta > 0
            ? 'rounded_up_height'
            : 'rounded_down_height';
    }

    return 'different';
}

export function simplifyRatioValues(width, height) {
    if (!width || !height) return { w: 0, h: 0 };
    const { arW, arH } = aspectRatioExact(width, height);
    return { w: arW, h: arH };
}

export function simplifyRatioString(width, height) {
    if (!width || !height) return '';
    return aspectRatioExact(width, height).label;
}
